import { render, staticRenderFns } from "./edit-game-service-content.vue?vue&type=template&id=12821608&scoped=true&"
import script from "./edit-game-service-content.vue?vue&type=script&lang=js&"
export * from "./edit-game-service-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12821608",
  null
  
)

export default component.exports